export default __webpack_public_path__ + "static/media/round6.802f2c9b.svg";